import { useQuery } from 'react-query';
import {
  QUERY_KEY_SPECIAL_PROJECTS,
  apiGetSpecialProjects,
} from 'api/special-progects/apiGetSpecialProjects';

import { useThisLang } from 'ui/LangUse';
import { useProContext } from 'store/ProReducer/useProContext';

export const useGetSpecialProjects = (params = {}, options = {}) => {
  const locale = useThisLang();

  const { modulId } = useProContext();

  return useQuery({
    queryKey: [QUERY_KEY_SPECIAL_PROJECTS, params, locale],
    queryFn: () => apiGetSpecialProjects(params, locale, modulId),
    ...options,
  });
};
